import React, { useEffect, useState } from "react";
import { RiCloseLine } from "react-icons/ri";

const AddToInvoice = (props) => {
    const [itemDetails, setItemDetails] = useState(
        {
            amount: "",
            date: "",
            description: "",
            responsible_dept: ""
        })
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setItemDetails({
            ...itemDetails,
            [name]: value,
        });
    };
    const responsibleDeptInitials = [
        { id: 1, status: false, tag: "Accident, Casualty and Emergency" },
        { id: 2, status: false, tag: "Surgery (operating theater)" },
        { id: 3, status: false, tag: "Outpatient" },
        { id: 4, status: false, tag: "Intensive Care Unit" },
        { id: 5, status: false, tag: "Cardiology" },
        { id: 6, status: false, tag: "Neurology" },
        { id: 7, status: false, tag: "Psychiatry" },
        { id: 8, status: false, tag: "Radiology" },
        { id: 9, status: false, tag: "Medical Laboratory" },
        { id: 10, status: false, tag: "Pharmacy" },
        { id: 11, status: false, tag: "Rehabilitation and Therapy" },
        { id: 12, status: false, tag: "ENT section" },
        { id: 13, status: false, tag: "Geriatric" },
        { id: 14, status: false, tag: "Gastroenterology" },
        { id: 15, status: false, tag: "Hematology" },
        { id: 16, status: false, tag: "Pediatrics" },
        { id: 17, status: false, tag: "Oncology" },
        { id: 18, status: false, tag: "Ophthalmology" },
        { id: 19, status: false, tag: "Urology" },
        { id: 20, status: false, tag: "Orthopedic" },
        { id: 21, status: false, tag: "Nursing" },
        { id: 22, status: false, tag: "Nutrition and Dietetics" },
    ];
    const handleFormSubmit = (e) => {
        e.preventDefault()
        if (props.edit) {
            props.updateItem(itemDetails)
        } else {
            props.addNewItem(itemDetails)
        }
    }
    useEffect(() => {
        if(props.edit ) {
            setItemDetails(props.item)
        }
    }, [])
    return (
        <>
            <dialog >
                <div className="w-[700px] bg-white rounded-md border relative">
                    <section className="font-euclid-circular-a w-full relative">
                        <div className="w-full bg-primary rounded-t-md" >
                            <div className="flex justify-between w-full align-middle">
                                <h2 className="text-white text-xl font-semibold leading-7 tracking-wide p-8">
                                    {
                                        !props.edit ? 'Create Invoice Item' : 'Edit Invoice Item'
                                    }
                                </h2>
                                <div className="leading-7 text-xl font-semibold  p-8">
                                    <button onClick={props.onClose}> <RiCloseLine color="white" size={30} /> </button>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="bg-white pt-6">
                        <article className="m-5"  >
                            <div className="step_inputs">
                                <label htmlFor="description">Description</label>
                                <textarea
                                    type="textarea"
                                    required
                                    id="description"
                                    placeholder="Enter a description..."
                                    name="description"
                                    defaultValue={itemDetails.description || ''}
                                    onChange={(e) => handleInputChange(e)}
                                />
                            </div>
                            <div className="w-full my-5">
                                <div className="w-full my-4">
                                    <div className="mb-3">
                                        <label htmlFor="department">Responsible department</label>
                                    </div>
                                    <select name="responsible_dept" required className="w-full step_input"
                                        id="responsible_dept" onChange={(e) => handleInputChange(e)}
                                        value={itemDetails?.responsible_dept}>
                                        <option disabled selected value={''}>
                                            Select department
                                        </option>
                                        {
                                            responsibleDeptInitials.map((item, index) => {
                                                return (
                                                    <option key={index} value={item.tag}>
                                                        {item.tag}
                                                    </option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>

                                <div className="step_input w-full my-4">
                                    <label htmlFor="amount">Amount (₦)</label>
                                    <div className="amount_box">
                                        <input
                                            onChange={(e) => handleInputChange(e)}
                                            name="amount"
                                            type="text"
                                            className="w-full p-[14px]"
                                            required
                                            id="amount"
                                            defaultValue={itemDetails.amount || ''}
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                        />
                                    </div>
                                </div>
                                <div className="step_input w-full my-4">
                                    <label htmlFor="date">Due Date</label>
                                    <div className="">
                                        <input
                                            className="date_input w-full"
                                            type="date"
                                            onChange={(e) => handleInputChange(e)}
                                            defaultValue={itemDetails.date || ''}
                                            required
                                            id="date"
                                            name="date"
                                            placeholder="DD/MM/YYYY"
                                        />
                                    </div>
                                </div>

                                <div className="w-full flex justify-end">
                                    <button type="submit"
                                        onClick={(e) => handleFormSubmit(e)} className="document_button bg-primary">
                                        {
                                            !props.edit ? 'Add' : 'Update'
                                        }
                                    </button>

                                </div>
                            </div>
                        </article>
                    </section>
                </div>
            </dialog>
        </>
    );
}

export default AddToInvoice;